import { isFirefox } from "./user-agent";

export const mouseWheel = isFirefox ? "DOMMouseScroll" : "mousewheel";

export const PointerEvents = {};

if ("ontouchstart" in document.documentElement) {
  PointerEvents.DOWN = "touchstart";
  PointerEvents.MOVE = "touchmove";
  PointerEvents.UP = "touchend";
} else {
  PointerEvents.DOWN = "mousedown";
  PointerEvents.MOVE = "mousemove";
  PointerEvents.UP = "mouseup";
}

export const GlobalEvents = {
  // editor
  SAVE_ACTIVITY: "activity:save",
  CANCEL_ACTIVITY: "activity:cancel",
  CLOSE_ACTIVITY: "activity:close",
  SCROLLING_ACTIVITY: "activity:scrolling",
  SHOW_PREVIEW: "preview:show",
  LOAD_CKEDTITOR: "ckeditor:load",
  INIT_CKEDTITOR: "ckeditor:init",
  SELECT_FILES: "files:select",

  // player
  INIT_SCORE: "score:init",
  CHANGE_SCORE: "score:change"
};
